import React from 'react';
import { useCharitableGivingContext } from '../../context/useCharitableGivingContext';
import { ReviewItem } from '../Review/components/ReviewItem';
import { formatCurrency } from '../../../../../CommonUtils/formatNumber';

export const DafGrantAmountReview = () => {
  const {
    workflow: {
      data: { dafGrantAmount },
    },
  } = useCharitableGivingContext();

  return (
    <ReviewItem
      label="Grant Amount"
      value={dafGrantAmount !== null ? formatCurrency(dafGrantAmount, { mantissa: 2 }) : '—'}
    />
  );
};
